<div fxLayout="row" fxLayoutAlign="center center">
    <mat-spinner class="app-spinner"></mat-spinner>
</div>
